module.exports = __webpack_public_path__ + "static/insertcoin-9301476c413d44ca883b46ebafc09fe5.png";